<template>
  <v-data-table
    :items="discountCodes"
    :disable-initial-sort="true"
    :total-items="discountCodes.length"
    :loading="isLoading"
    :no-data-text="trans('app.search.no_data')"
    :headers="headers"
    :rows-per-page-items="[25]"
  >
    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
    <template #items="props">
      <tr>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.code }}</td>
        <td>{{ props.item.start_date }}</td>
        <td>{{ props.item.end_date }}</td>
        <td>
          <is-active :is-active="props.item.is_active" />
        </td>
        <td>{{ props.item.limit }}</td>
        <td>{{ `app.discount_codes.${props.item.type}_type` | trans }}</td>
        <td>{{ `${props.item.value}${props.item.type === 'fixed' ? ' zł' : '%'}` }}</td>
        <td>
          <icon-button
              icon="launch"
              color="light-blue"
              cls="mr-0 ml-0"
              :tooltip="{ top: true, bottom: false, attach: false }"
              :iconOptions="{ small: true }"
              @click="openDiscountCode(props.item)"
          >
            {{ 'app.open' | trans }}
          </icon-button>
          <icon-button
            icon="edit"
            :color="props.item.usages > 0 ? 'grey' : 'success'"
            cls="mr-0 ml-0"
            :tooltip="{ top: true, bottom: false, attach: false }"
            :iconOptions="{ small: true }"
            @click="props.item.usages > 0 ? () => {} : editDiscountCode(props.item)"
            >
            {{ 'app.edit' | trans }}
          </icon-button>
          <icon-button
            icon="visibility"
            cls="mr-0 ml-0"
            @click="
              props.item.is_deactivated !== false || props.item.is_active !== false
                ? () => {}
                : handleActivateDiscountCode(props.item.id)
            "
            :color="props.item.is_deactivated !== false || props.item.is_active !== false ? 'grey' : 'green'"
            :tooltip="{ top: true, bottom: false, attach: false }"
            :iconOptions="{ small: true }"
          >
            {{ 'app.discount_codes.activate' | trans }}
          </icon-button>
          <icon-button
            icon="visibility_off"
            cls="mr-0 ml-0"
            @click="props.item.is_deactivated ? () => {} : handleDeactivateDiscountCode(props.item.id)"
            :color="props.item.is_deactivated ? 'grey' : 'red'"
            :tooltip="{ top: true, bottom: false, attach: false }"
            :iconOptions="{ small: true }"
          >
            {{ 'app.discount_codes.deactivate' | trans }}
          </icon-button>
          <icon-button
            icon="delete"
            cls="mr-0 ml-0"
            @click="props.item.usages > 0 ? () => {} : handleDelete(props.item.id)"
            :color="props.item.usages > 0 ? 'grey' : 'red'"
            :tooltip="{ top: true, bottom: false, attach: false }"
            :iconOptions="{ small: true }"
          >
            {{ 'app.delete' | trans }}
          </icon-button>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { trans } from '../../app';

export default {
  data: function () {
    return {
      isLoading: true,
      headers: [
        {
          text: trans('app.discount_codes.name'),
          align: 'left',
          sortable: false,
        },
        {
          text: trans('app.discount_codes.code'),
          align: 'left',
          sortable: false,
        },
        {
          text: trans('app.discount_codes.start_date'),
          align: 'left',
          sortable: false,
        },
        {
          text: trans('app.discount_codes.end_date'),
          align: 'left',
          sortable: false,
        },
        {
          text: trans('app.discount_codes.is_active'),
          align: 'left',
          sortable: false,
        },
        {
          text: trans('app.discount_codes.limit'),
          align: 'left',
          sortable: false,
        },
        {
          text: trans('app.discount_codes.type'),
          align: 'left',
          sortable: false,
        },
        {
          text: trans('app.discount_codes.value'),
          align: 'left',
          sortable: false,
        },
        {
          text: '',
          align: 'left',
          sortable: false,
          class: 'action-header',
        },
      ],
    };
  },
  methods: {
    ...mapActions(['fetchDiscountCodes', 'deactivateDiscountCode', 'deleteDiscountCode', 'activateDiscountCode']),
    editDiscountCode(discountCode) {
      this.$emit('edit-discount-code', discountCode);
    },
    openDiscountCode(discountCode) {
      this.$emit('view-discount-code', discountCode);
    },
    handleDeactivateDiscountCode(discountCodeId) {
      this.$confirmDanger(
          trans('app.discount_codes.should_be_deactivated'),
          trans('app.discount_codes.deactivate')
      ).then(async () => {
        await this.deactivateDiscountCode(discountCodeId);
        await this.fetchDiscountCodes();
      }).catch((error) => {
        this.sentryCaptureException(error);
      })
    },
    handleActivateDiscountCode(discountCodeId) {
      this.$confirmDanger(
          trans('app.discount_codes.should_be_activated'),
          trans('app.discount_codes.activate')
      ).then(async () => {
        await this.activateDiscountCode(discountCodeId);
        await this.fetchDiscountCodes();
      }).catch((error) => {
        this.sentryCaptureException(error);
      });
    },
    handleDelete(discountCodeId) {
      this.$confirmDanger(
          trans('app.discount_codes.should_be_deleted'),
          trans('app.delete')
      ).then(async () => {
        await this.deleteDiscountCode(discountCodeId);
        await this.fetchDiscountCodes();
      }).catch((error) => {
        this.sentryCaptureException(error);
      });
    },
  },
  computed: {
    ...mapGetters(['discountCodes']),
  },
  created() {
    this.fetchDiscountCodes().then(() => (this.isLoading = false));
  },
};
</script>

<style>
.action-header {
  min-width: 250px;
}
</style>
